import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "g-file-uploader" };
const _hoisted_2 = { class: "file-item" };
const _hoisted_3 = { class: "d-flex fw-bold ps-2 pe-3" };
const _hoisted_4 = { class: "flex-fill d-flex flex-column" };
const _hoisted_5 = { class: "text-start" };
const _hoisted_6 = ["href"];
const _hoisted_7 = { class: "text-muted small" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = {
    key: 1,
    class: "text-danger fw-bold"
};
const _hoisted_10 = {
    key: 0,
    class: "d-flex align-items-center"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
    key: 0,
    class: "bg-light small p-2 text-center"
};
const _hoisted_13 = {
    key: 1,
    class: "small p-2 text-center fw-bold"
};
const _hoisted_14 = {
    key: 2,
    class: "error-panel"
};
const _hoisted_15 = ["id"];
const _hoisted_16 = {
    id: "dropzone-text",
    class: "flex-box text-center"
};
const _hoisted_17 = {
    key: 0,
    class: "small text-muted"
};
const _hoisted_18 = {
    key: 0,
    class: "me-1"
};
const _hoisted_19 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DxProgressBar = _resolveComponent("DxProgressBar");
    const _component_DxFileUploader = _resolveComponent("DxFileUploader");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._files, (file, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(index + 1), 1),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                (_ctx.$utils.evalParams(_ctx.openUrl, file))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: _ctx.$utils.evalParams(_ctx.openUrl, file),
                                        target: "_blank"
                                    }, _toDisplayString(file.name ?? file.fileName), 9, _hoisted_6))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(file.name ?? file.fileName), 1)
                                    ], 64))
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                (file.uploadedAt)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('client.Forms.File.Uploaded')) + ": " + _toDisplayString(_ctx.$utils.formatDate(file.uploadedAt, "date-time")), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('client.Forms.File.Size')) + ": " + _toDisplayString(_ctx.$utils.formatFileSize(file.fileSize)), 1),
                                (file.message)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(file.message), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        (!_ctx.readOnly && !file.__locked)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("button", {
                                    class: "btn btn-sm btn-danger",
                                    onClick: ($event) => (_ctx.onDeleteFile(file))
                                }, _toDisplayString(_ctx.$t('client.Forms.File.Delete')), 9, _hoisted_11)
                            ]))
                            : _createCommentVNode("", true)
                    ]));
                }), 256)),
                (_ctx.readOnly && _ctx.readOnlyText && (!_ctx._files || _ctx._files.length === 0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.readOnlyText), 1))
                    : _createCommentVNode("", true),
                (_ctx.emptyText && (!_ctx._files || _ctx._files.length === 0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.emptyText), 1))
                    : _createCommentVNode("", true),
                (_ctx._errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx._errorMessage), 1))
                    : _createCommentVNode("", true),
                (!_ctx.readOnly)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        id: _ctx._elementID,
                        class: _normalizeClass(['drop-zone p-2', (_ctx.multiple || (_ctx._files?.length ?? 0) === 0) ? '' : 'hidden', _ctx._isDropZoneActive ? 'active' : ''])
                    }, [
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('client.Forms.File.DragForUpload')), 1),
                            (!_ctx.readOnly && (_ctx.maxFileSize > 0 || (_ctx.allowedFileExtensions && _ctx.allowedFileExtensions.length > 0)))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    (_ctx.maxFileSize > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('client.Forms.File.MaxFileSize', { size: _ctx.maxFileSize, sizeText: _ctx.$utils.formatFileSize(_ctx.maxFileSize, true, 2) })), 1))
                                        : _createCommentVNode("", true),
                                    (_ctx.allowedFileExtensions && _ctx.allowedFileExtensions.length > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('client.Forms.File.AllowedTypes', { extensions: _ctx.allowedFileExtensions, extensionsText: _ctx.allowedFileExtensions.join(', ') })), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            _createVNode(_component_DxProgressBar, {
                                id: "upload-progress",
                                min: 0,
                                max: 100,
                                width: "30%",
                                "show-status": false,
                                visible: _ctx._uploadProgressVisible,
                                value: _ctx._uploadProgress
                            }, null, 8, ["visible", "value"])
                        ])
                    ], 10, _hoisted_15))
                    : _createCommentVNode("", true)
            ]),
            (!_ctx.readOnly)
                ? (_openBlock(), _createBlock(_component_DxFileUploader, {
                    key: 0,
                    name: "file",
                    ref: "fileUploader",
                    "upload-mode": "instantly",
                    "dialog-trigger": '#' + _ctx._elementID,
                    "drop-zone": '#' + _ctx._elementID,
                    "upload-url": _ctx.uploadUrl,
                    multiple: _ctx.multiple,
                    "chunk-size": _ctx.chunkSize,
                    "max-file-size": _ctx.maxFileSize,
                    accept: _ctx.accept,
                    "allowed-file-extensions": _ctx.allowedFileExtensions,
                    visible: false,
                    onDropZoneEnter: _ctx.onDropZoneEnter,
                    onDropZoneLeave: _ctx.onDropZoneLeave,
                    onProgress: _ctx.onProgress,
                    onUploaded: _ctx.onUploadedFile,
                    onUploadStarted: _ctx.onUploadStarted,
                    onUploadError: _ctx.onUploadedError,
                    onFilesUploaded: _ctx.onUploaded,
                    onValueChanged: _ctx.onValueChanged
                }, null, 8, ["dialog-trigger", "drop-zone", "upload-url", "multiple", "chunk-size", "max-file-size", "accept", "allowed-file-extensions", "onDropZoneEnter", "onDropZoneLeave", "onProgress", "onUploaded", "onUploadStarted", "onUploadError", "onFilesUploaded", "onValueChanged"]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 16, ["name", "error-message", "label"]));
}
